export default __webpack_public_path__ + "static/media/avatar_unicorn3.bf76f6ad.mp3";